var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed z-50 flex items-center justify-between w-full px-6 py-4 bg-white"},[_c('div',{staticClass:"flex items-center"},[_c('inertia-link',{attrs:{"href":"/user/profile"}},[_c('div',{staticClass:"font-bold text-gray-700"},[_vm._v("\n                "+_vm._s(_vm.user.name)+"\n            ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }